var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0H3C1.89543 0 1 0.895431 1 2V14C1 15.1046 1.89543 16 3 16H13C14.1046 16 15 15.1046 15 14V5.5H10.5C9.94772 5.5 9.5 5.05228 9.5 4.5V0ZM11 0.25V4H14.75L11 0.25ZM4.75 12.5C4.33579 12.5 4 12.1642 4 11.75V9.25C4 8.83579 4.33579 8.5 4.75 8.5C5.16421 8.5 5.5 8.83579 5.5 9.25V11.75C5.5 12.1642 5.16421 12.5 4.75 12.5ZM8 12.5C7.58579 12.5 7.25 12.1642 7.25 11.75V7.25C7.25 6.83579 7.58579 6.5 8 6.5C8.41421 6.5 8.75 6.83579 8.75 7.25V11.75C8.75 12.1642 8.41421 12.5 8 12.5ZM11.25 12.5C10.8358 12.5 10.5 12.1642 10.5 11.75V10.25C10.5 9.83579 10.8358 9.5 11.25 9.5C11.6642 9.5 12 9.83579 12 10.25V11.75C12 12.1642 11.6642 12.5 11.25 12.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.238b5294.svg";
export { ForwardRef as ReactComponent };